import styles from "../../foryou/_components/DesctopComponents/Desctop.module.scss";
import {useTranslation} from "react-i18next";
import OverlayRatingIcon from "../../../components/icons/searchIcons/OverlayRatingIcon";
import OverlayTomatoRatingIcon from "../../../components/icons/searchIcons/OverlayTomatoRatingIcon";

const formatRating = (rating?: number | null) => (rating != null ? rating.toFixed(1) : undefined);

interface IProps {
  title: string,
  releaseDate: string,
  genres: any,
  runtime: number,
  voteAverage: number,
  imdbRating?: number | null,
  rottenTomatoesRating?: number | null,
}

const InfoData = ({
  title,
  releaseDate,
  genres,
  runtime,
  voteAverage,
  imdbRating,
  rottenTomatoesRating,
}: IProps) => {
  const {t} = useTranslation();
  const imdbDisplay = formatRating(imdbRating);
  const tomatoDisplay = formatRating(rottenTomatoesRating);

  return (
    <div className={styles.detailsInfoData}>
      <div className={styles.rowInfoWrapper}>
        <span>{releaseDate ? releaseDate.split("-")[0] : "2023"}</span>
        <span>USA</span>
        {false && (
          <span className={styles.badge}>Скоро</span>
        )}
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.detailsGenres}>
        {genres && (
          <>
            {genres[0] && <span>{t(`${genres[0]?.name}`)}</span>}
            {genres[1] && <span>{t(`${genres[1]?.name}`)}</span>}
          </>
        )}
        <span>{runtime} {t('minutes')}</span>
      </div>
      {(imdbDisplay || tomatoDisplay) && (
        <div className={styles.detailsRatingsRow}>
          {imdbDisplay && (
            <span className={styles.detailsRating}>
              <OverlayRatingIcon />
              {imdbDisplay}
            </span>
          )}
          {tomatoDisplay && (
            <span className={styles.detailsRating}>
              <OverlayTomatoRatingIcon />
              {tomatoDisplay}
            </span>
          )}
        </div>
      )}
    </div>
  )
}

export default InfoData;
